import { render, staticRenderFns } from "./ShortlistedCandidate.vue?vue&type=template&id=155f866f&scoped=true&"
import script from "./ShortlistedCandidate.vue?vue&type=script&lang=js&"
export * from "./ShortlistedCandidate.vue?vue&type=script&lang=js&"
import style0 from "./ShortlistedCandidate.vue?vue&type=style&index=0&id=155f866f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155f866f",
  null
  
)

export default component.exports